import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=3deef1e6"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/samuelscn/Área de Trabalho/veins/veins-api/VeinsEnergia-api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3deef1e6')) {
      api.createRecord('3deef1e6', component.options)
    } else {
      api.reload('3deef1e6', component.options)
    }
    module.hot.accept("./edit.vue?vue&type=template&id=3deef1e6", function () {
      api.rerender('3deef1e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/components/distributor/edit.vue"
export default component.exports